<template>
  <AdvertisedPayment :selected-offer />
</template>

<script setup lang="ts">
import AdvertisedPayment from '~/scopes/product-core/components/presentationals/AdvertisedPayment/AdvertisedPayment.vue'
import { useFetchPickers } from '~/scopes/product-core/composables/useFetch/useFetchPickers/useFetchPickers'

const { selectedOffer } = useFetchPickers()
</script>
